import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, MapPin, Ship, Plane, Building2, Key, TrendingUp, Home as HomeIcon, Sparkles } from 'lucide-react';
import { translations } from '../utils/translations';

const Home = ({ language = 'en' }) => {
  const t = translations[language];
  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      const parallaxElements = document.querySelectorAll('.parallax');
      parallaxElements.forEach(el => {
        const speed = el.dataset.speed || 0.5;
        el.style.transform = `translateY(${scrolled * speed}px)`;
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const services = [
    {
      icon: Building2,
      title: t.services.realEstate.title,
      description: t.services.realEstate.description
    },
    {
      icon: Key,
      title: t.services.rentals.title,
      description: t.services.rentals.description
    },
    {
      icon: TrendingUp,
      title: t.services.investment.title,
      description: t.services.investment.description
    },
    {
      icon: HomeIcon,
      title: t.services.management.title,
      description: t.services.management.description
    },
    {
      icon: Building2,
      title: t.services.development.title,
      description: t.services.development.description
    },
    {
      icon: Ship,
      title: t.services.yacht.title,
      description: t.services.yacht.description
    },
    {
      icon: HomeIcon,
      title: t.services.villa.title,
      description: t.services.villa.description
    },
    {
      icon: Plane,
      title: t.services.aviation.title,
      description: t.services.aviation.description
    },
    {
      icon: ChevronDown,
      title: t.services.events.title,
      description: t.services.events.description
    }
  ];

  const markets = [
    {
      name: t.markets.mediterranean.name,
      description: t.markets.mediterranean.description,
      image: 'https://images.unsplash.com/photo-1769766779588-5afc26f9518a'
    },
    {
      name: t.markets.dubai.name,
      description: t.markets.dubai.description,
      image: 'https://images.unsplash.com/photo-1740482881422-899f17e54d61'
    },
    {
      name: t.markets.miami.name,
      description: t.markets.miami.description,
      image: 'https://images.unsplash.com/photo-1763690561413-81b1e92409eb'
    },
    {
      name: t.markets.newYork.name,
      description: t.markets.newYork.description,
      image: 'https://images.unsplash.com/photo-1757264119016-7e6b568b810d'
    }
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-image parallax" data-speed="0.3">
          <img 
            src="https://images.unsplash.com/photo-1622015663319-e97e697503ee" 
            alt="Luxury Contemporary Villa"
          />
        </div>
        <div className="hero-content">
          <div className="hero-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_prime-estates-16/artifacts/4mmxc3yl_Atelier_logo_vett_2.pdf" 
              alt="Atelier - Beauty and Sun"
              className="hero-logo-image"
            />
          </div>
          <div className="hero-scroll">
            <ChevronDown className="scroll-icon" />
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="section-container">
          <div className="section-header">
            <p className="section-overline">{t.home.servicesOverline}</p>
            <h2>{t.home.servicesTitle}</h2>
            <p className="section-description">
              {t.home.servicesDescription}
            </p>
          </div>

          <div className="services-grid">
            {services.map((service) => (
              <div key={service.title} className="service-card">
                <div className="service-icon">
                  <service.icon size={28} strokeWidth={1} />
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Ibiza Focus Section */}
      <section className="ibiza-focus-section">
        <div className="section-container">
          <div className="ibiza-content-panoramic">
            <div className="ibiza-header">
              <p className="section-overline">{t.home.ibizaOverline}</p>
              <h2>{t.home.ibizaTitle}</h2>
            </div>
            
            <div className="ibiza-image-panoramic">
              <img 
                src="https://customer-assets.emergentagent.com/job_prime-estates-16/artifacts/5khdxh1i_IMG_2995.jpeg" 
                alt="Contemporary Ibiza Luxury"
              />
            </div>
            
            <div className="ibiza-text-below">
              <p className="ibiza-description">
                {t.home.ibizaDescription}
              </p>
              <p className="ibiza-detail">
                {t.home.ibizaDetail}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>{t.home.ctaTitle}</h2>
          <p>{t.home.ctaDescription}</p>
          <Link to="/contact" className="cta-button">
            {t.home.ctaButton}
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
